export { default as LegalsActions, types as LegalsTypes } from './actions';
export { default as LegalsSagas } from './sagas';
export { default as LegalsReducers } from './reducers';
